/**
 * @generated SignedSource<<c5d2251edab4b35806abcb64044ff788>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type EventResult = "FAILURE" | "PARTIAL" | "SUCCESS" | "UNDEFINED" | "%future added value";
export type EventState = "DONE" | "SCHEDULED" | "STARTED" | "UNDEFINED" | "%future added value";
export type ModelType = "COMPOSITE" | "CRUSTAL" | "SUBDUCTION" | "%future added value";
export type TaskSubType = "AGGREGATE_SOLUTION" | "DISAGG" | "HAZARD" | "INVERSION" | "OPENQUAKE_HAZARD" | "REPORT" | "RUPTURE_SET" | "SCALE_SOLUTION" | "SOLUTION_TO_NRML" | "TIME_DEPENDENT_SOLUTION" | "UNDEFINED" | "%future added value";
export type GeneralTaskChildrenTabQuery$variables = {
  id: string;
};
export type GeneralTaskChildrenTabQuery$data = {
  readonly node: {
    readonly children?: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly child: {
            readonly __typename: string;
            readonly arguments?: ReadonlyArray<{
              readonly k: string | null | undefined;
              readonly v: string | null | undefined;
            } | null | undefined> | null | undefined;
            readonly created?: any | null | undefined;
            readonly duration?: number | null | undefined;
            readonly files?: {
              readonly edges: ReadonlyArray<{
                readonly node: {
                  readonly file: {
                    readonly __typename: string;
                    readonly id?: string;
                    readonly meta?: ReadonlyArray<{
                      readonly k: string | null | undefined;
                      readonly v: string | null | undefined;
                    } | null | undefined> | null | undefined;
                  } | null | undefined;
                } | null | undefined;
              } | null | undefined>;
            } | null | undefined;
            readonly id?: string;
            readonly inversion_solution?: {
              readonly __typename: string;
              readonly id?: string;
              readonly mfd_table?: {
                readonly id: string;
              } | null | undefined;
            } | null | undefined;
            readonly result?: EventResult | null | undefined;
            readonly state?: EventState | null | undefined;
            readonly task_type?: TaskSubType | null | undefined;
          } | null | undefined;
        } | null | undefined;
      } | null | undefined>;
    } | null | undefined;
    readonly id?: string;
    readonly model_type?: ModelType | null | undefined;
  } | null | undefined;
};
export type GeneralTaskChildrenTabQuery = {
  response: GeneralTaskChildrenTabQuery$data;
  variables: GeneralTaskChildrenTabQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "model_type",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v5 = [
  (v2/*: any*/)
],
v6 = {
  "kind": "InlineFragment",
  "selections": (v5/*: any*/),
  "type": "Node",
  "abstractKey": "__isNode"
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "task_type",
  "storageKey": null
},
v8 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "k",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "v",
    "storageKey": null
  }
],
v9 = {
  "alias": null,
  "args": null,
  "concreteType": "TaskTaskRelationConnection",
  "kind": "LinkedField",
  "name": "children",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "TaskTaskRelationEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "TaskTaskRelation",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "child",
              "plural": false,
              "selections": [
                (v4/*: any*/),
                (v6/*: any*/),
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v7/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": null,
                      "kind": "LinkedField",
                      "name": "inversion_solution",
                      "plural": false,
                      "selections": [
                        (v4/*: any*/),
                        (v6/*: any*/),
                        {
                          "kind": "InlineFragment",
                          "selections": [
                            (v2/*: any*/),
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "Table",
                              "kind": "LinkedField",
                              "name": "mfd_table",
                              "plural": false,
                              "selections": (v5/*: any*/),
                              "storageKey": null
                            }
                          ],
                          "type": "InversionSolution",
                          "abstractKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "type": "AutomationTask",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v7/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "FileRelationConnection",
                      "kind": "LinkedField",
                      "name": "files",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "FileRelationEdge",
                          "kind": "LinkedField",
                          "name": "edges",
                          "plural": true,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "FileRelation",
                              "kind": "LinkedField",
                              "name": "node",
                              "plural": false,
                              "selections": [
                                {
                                  "alias": null,
                                  "args": null,
                                  "concreteType": null,
                                  "kind": "LinkedField",
                                  "name": "file",
                                  "plural": false,
                                  "selections": [
                                    (v4/*: any*/),
                                    (v6/*: any*/),
                                    {
                                      "kind": "InlineFragment",
                                      "selections": [
                                        (v2/*: any*/),
                                        {
                                          "alias": null,
                                          "args": null,
                                          "concreteType": "KeyValuePair",
                                          "kind": "LinkedField",
                                          "name": "meta",
                                          "plural": true,
                                          "selections": (v8/*: any*/),
                                          "storageKey": null
                                        }
                                      ],
                                      "type": "RuptureSet",
                                      "abstractKey": null
                                    }
                                  ],
                                  "storageKey": null
                                }
                              ],
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "type": "RuptureGenerationTask",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "state",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "result",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "created",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "duration",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "KeyValuePair",
                      "kind": "LinkedField",
                      "name": "arguments",
                      "plural": true,
                      "selections": (v8/*: any*/),
                      "storageKey": null
                    }
                  ],
                  "type": "AutomationTaskInterface",
                  "abstractKey": "__isAutomationTaskInterface"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "GeneralTaskChildrenTabQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v9/*: any*/)
            ],
            "type": "GeneralTask",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "GeneralTaskChildrenTabQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v3/*: any*/),
              (v9/*: any*/)
            ],
            "type": "GeneralTask",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "a69564a6e5854652de6b725d7d74d44a",
    "id": null,
    "metadata": {},
    "name": "GeneralTaskChildrenTabQuery",
    "operationKind": "query",
    "text": "query GeneralTaskChildrenTabQuery(\n  $id: ID!\n) {\n  node(id: $id) {\n    __typename\n    ... on GeneralTask {\n      id\n      model_type\n      children {\n        edges {\n          node {\n            child {\n              __typename\n              ... on Node {\n                __isNode: __typename\n                id\n              }\n              ... on AutomationTask {\n                task_type\n                inversion_solution {\n                  __typename\n                  ... on Node {\n                    __isNode: __typename\n                    id\n                  }\n                  ... on InversionSolution {\n                    id\n                    mfd_table {\n                      id\n                    }\n                  }\n                }\n              }\n              ... on RuptureGenerationTask {\n                task_type\n                files {\n                  edges {\n                    node {\n                      file {\n                        __typename\n                        ... on Node {\n                          __isNode: __typename\n                          id\n                        }\n                        ... on RuptureSet {\n                          id\n                          meta {\n                            k\n                            v\n                          }\n                        }\n                      }\n                    }\n                  }\n                }\n              }\n              ... on AutomationTaskInterface {\n                __isAutomationTaskInterface: __typename\n                state\n                result\n                created\n                duration\n                arguments {\n                  k\n                  v\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "8fb0bdf569764acdc9ec62d112d5c5b9";

export default node;
